import React from 'react';
import { useNavigate } from 'react-router-dom';

import ButtonCustom from '@/components/common/ui/button';
import { useTranslation } from '@/config/i18n';
import PATH from '@/routes/path';

const MentorTopHeader: React.FC = () => {
  const [t] = useTranslation('');
  const navigate = useNavigate();

  function handleNavigateNew() {
    navigate(`${PATH.mentor_management}/${PATH.mentor_management_new}`);
  }

  return (
    <div className="header-top flex items-center justify-between">
      <h2 className="title">{t('user_list.title_mentor')}</h2>
      <div className="action flex items-center">
        <ButtonCustom onClick={() => handleNavigateNew()}>
          <span className="flex relative items-center">
            <span className="pi pi-plus mr-2" />
            <span>{t('user_list.new')}</span>
          </span>
        </ButtonCustom>
      </div>
    </div>
  );
};

export default MentorTopHeader;
